<template>
	<fragment>
		<common-header
			subname="게시판관리"
			name="게시글 작성"
			v-bind:menus="menus"
			v-bind:buttons="buttons"
		></common-header>

		<section ref="container" class="container">
			<common-side-menu :menus="sideMenus" :btnList="sideButtons"></common-side-menu>

			<div class="container-fiuld class-making-box clearfix">
				
				<template v-if="parentsArticle">
					<div class="title-box m-b-30 b-b clearfix">
						<div class="f-18 pull-left text-blue p-10">
							{{sideMenus.length ? sideMenus.find(e=>e.selected).name : ''}}
							<img src="images/view-off.png" alt="노출안함" v-if="selectedBoard && selectedBoard.hideEnable"/>
						</div>
					</div>
					
					<div class="white-box m-t-10 clearfix">
						<p class="f-18 m-b-15 m-t-10 text-bold text-blue">{{parentsArticle.title}}</p>
						<div class="input-group full-width">
							<span class="input-group-addon w100 text-left">
								<b>분류 :</b> {{parentsArticle.articleCategoryNm || "미분류"}}
							</span>
							<span class="input-group-addon w100 text-left">
								<b>작성자 :</b> {{parentsArticle.name}}{{parentsArticle.mberId && `(${parentsArticle.mberId})`|| ""}}
							</span>
							<span class="input-group-addon w160 text-left">
								<b>작성일 :</b> {{parentsArticle.regDate}}
							</span>
							<span class="input-group-addon w60 text-left">
								<b>조회 :</b> {{ parentsArticle.lookupCount }}
							</span>
						</div>
						<div class="on-border round p-15 m-t-5 m-b-10" v-html="parentsArticle.content"></div>
						<ul class="m-b-10" v-if="parentsArticle.articleFileMappingList.length > 0">
							<li v-for="file in parentsArticle.articleFileMappingList" :key="`article-file-${file.atchFileId}`">
								<a class="down-btn" :href="'/download/'+file.atchFileId" target="_blank" title="새창열림">
									{{file.file.orignlFileNm}} {{'('+numberFormat(Math.ceil(file.file.fileMg/1024))+'KB)'}}
								</a>
							</li>
						</ul>
					</div>
					<!-- <div class="white-box m-t-10 clearfix">
						<div class="comment" v-for="comment in parentsArticle.commentList" :key="`comment-${hash(comment)}`">
							<p class="m-b-0 clearfix">
								{{comment.mberId}} ｜ {{comment.regDate}}
								<span class="pull-right">
									<a class="modify"></a>
									<a class="del"></a>
								</span>
							</p>
							<div class="bg-lightgray p-15" style="line-height: 1.4;" v-html="comment.content ? comment.content.replace(/\n/g, '<br>') : ''"></div>
						</div>
					</div> -->
				</template>

				<div class="title-box m-t-10 m-b-30 b-b clearfix">
					<div class="f-18 pull-left text-blue p-10">
						{{parentsArticle && "답글쓰기" || 
						(sideMenus.length && sideMenus.find(e=>e.selected).name || '')}}
						<img src="images/view-off.png" alt="노출안함" v-if="!parentsArticle && selectedBoard && selectedBoard.hideEnable"/>
					</div>
				</div>
				
				<div class="input-group full-width">
					<span class="input-group-addon w160 p-r-5">
						<select class="form-control round m-b-0" v-model="noticeEnable">
							<option value="0">공지 설정 하지 않음</option>
							<option value="1">공지 설정 함</option>
						</select>
					</span>

					<span class="input-group-addon w160 p-r-5">
						<select class="form-control round m-b-0" v-model="articleCategoryId" v-if="sideMenus.length">
							<option value="0">분류 선택 안함</option>
							<option v-for="category in sideMenus.find(e=>e.selected).board.articleCategoryList"
								:key="`option-category-${category.articleCategoryId}`" :value="category.articleCategoryId">
								{{category.name}}
							</option>
						</select>
					</span>
					<span class="input-group-addon">
						<input class="form-control round m-b-0" type="text" placeholder="제목을 입력하세요." v-model="title">
					</span>
				</div>
				
				<div class="input-group full-width m-t-10">

					<span class="input-group-addon bg-white on-border round v-mid text-left p-5">
						<span class="text-darkgray" v-for="(fileName, idx) in articleFileNames" :key="`article-file-${fileName}`">
							{{fileName}}<a @click="articleFileMappingList.splice(idx, 1); articleFileNames.splice(idx, 1)" class="f-16 m-l-5 m-r-10 text-blue text-bold">×</a>
						</span>
					</span>
					<span class="input-group-addon w40 v-mid p-l-5">
						<input id="file" type="file" style="display: none;" ref="fileRef" @change="fileUpload">
						<label for="file" class="btn btn-darkgray f-14 round full-width">+</label>
					</span>
				</div>
				<div v-if="progressShow"> 
					첨부파일 업로드 진행사항 <progress class="input-group-addon" max="100" :value.prop="progress" ></progress>
				</div>
				
				<div class="input-group full-width m-t-10 bg-white">
					<textarea class="full-width editorContent" cols="30" rows="4"></textarea>
				</div>
				
				<button class="btn btn-blue round m-t-30 m-b-30 pull-right" type="button" @click="putArticle">완료하기</button>
				<button class="btn btn-red round m-t-30 m-b-30 m-r-5 pull-right" type="button" @click="routerBackPage">취소</button>
			</div>
		</section>
		<common-footer></common-footer>
	</fragment>
</template>

<script>
/**
 * TODO: 게시물 작성, 답글 권한 체크해야할 부분
 * 게시판 조회 (사이드 메뉴 리스트)
 * 
 * 게시물 조회 (본문)
 */
import fnAdjustHeight from '../mixins/fnAdjustHeight.js'
import CommonHeader from '../components/CommonHeader.vue'
import CommonFooter from '../components/CommonFooter.vue'
import CommonSideMenu from '../components/CommonSideMenu.vue'
import Axios from 'axios'
import server from '../statics/server'
//import axios from 'axios'
//import server from '../statics/server.js'

export default {
	name: 'ViewBoardWrite',
	mixins: [fnAdjustHeight],
	components: {
		CommonHeader,
		CommonFooter,
		CommonSideMenu,
	},
	mounted: function() {
		this.getBoardList();
		this.getParentsArticle();

		let that = this;
		window.tinymce.init({
			selector: '.editorContent',
			min_height: 900,
			branding: false,
			plugins: [
				"autoresize",
				"advlist autolink lists link image charmap print preview anchor",
				"searchreplace visualblocks code fullscreen",
				"insertdatetime media table paste imagetools wordcount lineheight addfile"
			],
			content_style: "body {margin: 40px 2rem !important; line-height: 1.5; width:866px;} body > p {margin: 0}",
			toolbar_mode: 'wrap',
			toolbar: "| insertfile undo redo | styleselect fontselect fontsizeselect lineheight| bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image addfile",
			fontsize_formats: "8pt 10pt 12pt 14pt 16pt 18pt 20pt 22pt 24pt 30pt 32pt 34pt 36pt 38pt 40pt",
			lineheight_formats: "1 1.5 2 2.5 3 3.5 4 4.5 5",
			images_upload_handler: function(blobInfo, success) {
				const formData = new FormData();
				formData.append('file', blobInfo.blob(), blobInfo.filename());
				Axios.post(`${server.addr()}${server.api.FILE}`, formData).then((response) => {
					success("/download/" + response.data);
				});
			},
			files_upload_handler: function(fileObj, success) {
				const formData = new FormData();
				formData.append('file', fileObj);
				Axios.post(`${server.addr()}${server.api.FILE}`, formData).then((response) => {
					success("/download/" + response.data);
				});
			},
			setup: function(editor) {
				editor.on('init', function() {
					editor.setContent(that.content);
				});
				editor.on("change", function() {
					that.content = editor.getContent();
				})
			}
		}).then((r) => {this.editorContent = r[0]});
	},
	data: function() {
		return {
			menus : [
				{name:'게시물 목록',link:"/board",selected:true},
			],
			buttons : [
			],
			sideButtons: [],
			sideMenus: [],
			modals: {
				//ModalOnlineClass: ModalOnlineClass.default()
				//ModalOnlineClass.
			},

			selectedBoard: null,
			parentsArticle: null,

			parentsId: this.$route.params.parentsId ? this.$route.params.parentsId : 0 ,
			noticeEnable: 0,
			articleCategoryId: 0,
			articleFileNames: [],
			articleFileMappingList: [],
			title: "",
			content: "",
			editorContent: null,
			
			progressShow: false,
			progress: 0,
		}
	},
	methods: {
		routerBackPage: function() {
			this.$router.go(-1);
		},
		routerBoardList: function(){
			const { boardId } = this.$route.params;
			this.$router.push(`/board/${boardId}`);
		},
		getBoardList: async function() {
			try {
				const { data } = await Axios.post(`${server.addr()}${server.api.BOARD}`, { lecId: 0 });
				const { trashBoardId } = this;
				let { boardId } = this.$route.params;
				let trashBoardInfo = "";
				this.sideMenus = data.list.map(e => {
					const info = {
						board: e,
						selected: e.boardId === parseInt(boardId),
						name: e.boardName,
						hideEnable: e.hideEnable || 0,
						link: `/board/${e.boardId}`
					}
					if(!boardId) { // !! boardId = 0인 게시판은 없다. , 게시판 번호가 없을 때, 상단을 클릭
						this.selectedBoard = e;
						boardId = e.boardId;
						this.$router.push(`/board/${e.boardId}`);
					}
					if(e.boardId === parseInt(boardId)) { // selectedBoard 선택
						this.selectedBoard = e;
						this.link = `board.html?state=1&lecId=${e.lecId}&boardId=${e.boardId}`;
						this.moveLink =`/${server.hostParentName}/${this.link}`;
					}
					if(trashBoardId && trashBoardId === e.boardId) trashBoardInfo = info; // 휴지통 정보 저장
					return info;
				}).filter(e => parseInt(e.board.boardId) !== trashBoardId); // 휴지통 게시판 제외
				if(trashBoardId) this.sideMenus = [...this.sideMenus, trashBoardInfo]; // 휴지통 하단으로 내리기
			} catch(e) {e}
		},
		getParentsArticle: async function() {
			try {
				if(!this.parentsId) return;
				const {data} = await Axios.post(`${server.addr()}${server.api.ARTICLE}/${this.parentsId}`, {});
				this.parentsArticle = data.return;
			} catch(e) { e }
		},
		fileUpload: async function() {
			const formData = new FormData();
			const { fileRef } = this.$refs
			formData.append("file", fileRef.files[0]);
			try {
				this.progress = 0;
				this.progressShow = true;
				const { data } = await Axios.post(`${server.addr()}${server.api.FILE}`, formData, {
					onUploadProgress: progressEvent => this.progress = parseInt(Math.round(( progressEvent.loaded / progressEvent.total ) * 100 ))
				});
				this.progressShow = false;
				this.articleFileNames.push(fileRef.files[0].name);
				this.articleFileMappingList.push({atchFileId:data});
			} catch(e) {
				//TODO: error exception
			}
		},
		putArticle: async function() {
			const { noticeEnable, articleCategoryId, articleFileMappingList, title, content, parentsId } = this;
			const { boardId } = this.$route.params;
			try {
				await Axios.put(`${server.addr()}${server.api.ARTICLE}`, [{
					noticeEnable, articleCategoryId, articleFileMappingList, title, content, parentsId, boardId
				}]);
				this.routerBoardList();
			} catch(e) {
				// TODO: error exception
			}
		},
		numberFormat: function(inputNumber) {
			if (!inputNumber) return 0;
			return inputNumber.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
		}
	}
}
</script>
<style scope>
	tr {height: 50px;}

	.recycle {
		fill: #fff;
		fill-rule: evenodd;
	}

	.btn-group .btn:hover .recycle {
		fill: #fff;
		fill-rule: evenodd;
	}
</style>